const dict = {
  uk: {
    messages: 'Повідомлення',
    searchByNickname: 'Пошук за нікнеймом...',
    searching: 'Пошук...',
    noUsersFound: 'Користувачів не знайдено',
    viewProfile: 'Переглянути профіль',
    writeMessage: 'Написати повідомлення',
    noConversations: 'Немає розмов. Знайдіть користувача вище, щоб почати чат.',
    noMessagesYet: 'Немає повідомлень',
    backToConversations: 'Назад до списку розмов',
    conversationStart: 'Це початок вашої розмови з {{name}}. Напишіть перше повідомлення!',
    forwardedFrom: 'Переслано від {{name}}',
    edited: 'змінено',
    editedDot: '· змінено',
    recording: 'Запис...',
    editingMessage: 'Редагування повідомлення',
    cancel: 'Скасувати',
    save: 'Зберегти',
    recordVoiceMessage: 'Записати голосове повідомлення',
    typeMessage: 'Написати повідомлення...',
    selectChatToStart: 'Оберіть чат, щоб почати спілкуватися',
    deleteMessage: 'Видалити повідомлення',
    deleteMessageConfirm: 'Ви впевнені, що хочете видалити це повідомлення? Цю дію неможливо скасувати.',
    delete: 'Видалити',
    sendErrorFallback: 'Помилка відправки повідомлення',
    forwardTitle: 'Переслати повідомлення',
    voiceMessage: 'Голосове повідомлення',
    searchChat: 'Пошук чату...',
    nothingFound: 'Нічого не знайдено',
    noChatsToForward: 'Немає чатів для пересилання',
    forwarding: 'Пересилання...',
    forwardButton: 'Переслати',
    forwardButtonCount: 'Переслати ({{count}})',
    menuLike: 'Вподобати',
    menuUnlike: 'Прибрати вподобання',
    menuForward: 'Переслати',
    menuEdit: 'Редагувати',
    menuDelete: 'Видалити',
    voicePlay: 'Відтворити',
    voicePause: 'Пауза',
  },
  en: {
    messages: 'Messages',
    searchByNickname: 'Search by nickname...',
    searching: 'Searching...',
    noUsersFound: 'No users found',
    viewProfile: 'View profile',
    writeMessage: 'Write a message',
    noConversations: 'No conversations. Find a user above to start a chat.',
    noMessagesYet: 'No messages',
    backToConversations: 'Back to conversations',
    conversationStart: 'This is the start of your conversation with {{name}}. Send the first message!',
    forwardedFrom: 'Forwarded from {{name}}',
    edited: 'edited',
    editedDot: '· edited',
    recording: 'Recording...',
    editingMessage: 'Editing message',
    cancel: 'Cancel',
    save: 'Save',
    recordVoiceMessage: 'Record voice message',
    typeMessage: 'Type a message...',
    selectChatToStart: 'Select a chat to start messaging',
    deleteMessage: 'Delete message',
    deleteMessageConfirm: 'Are you sure you want to delete this message? This action cannot be undone.',
    delete: 'Delete',
    sendErrorFallback: 'Failed to send message',
    forwardTitle: 'Forward message',
    voiceMessage: 'Voice message',
    searchChat: 'Search chats...',
    nothingFound: 'Nothing found',
    noChatsToForward: 'No chats to forward to',
    forwarding: 'Forwarding...',
    forwardButton: 'Forward',
    forwardButtonCount: 'Forward ({{count}})',
    menuLike: 'Like',
    menuUnlike: 'Unlike',
    menuForward: 'Forward',
    menuEdit: 'Edit',
    menuDelete: 'Delete',
    voicePlay: 'Play',
    voicePause: 'Pause',
  },
};

export default dict;
